import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const Count = styled.small`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  color: ${colors.gray650};
`;
